function laterDate(a: Date | null, b: Date | null): Date | null {
  if (!a) return b;
  if (!b) return a;
  return a.getTime() >= b.getTime() ? a : b;
}

function asDate(value: Date | string | null | undefined): Date | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function lastLoginFromManagers(
  managers: Array<{ lastEntry?: Date | string | null }> | undefined,
): Date | null {
  let latest: Date | null = null;
  for (const manager of managers ?? []) {
    latest = laterDate(latest, asDate(manager.lastEntry));
  }
  return latest;
}

export function formatPartnerOrgActivityDate(
  value: Date | string | null | undefined,
): string {
  const date = asDate(value);
  if (!date) return "אין";
  return date.toLocaleString("he-IL", {
    dateStyle: "short",
    timeStyle: "short",
  });
}

export function formatPartnerOrgFollowUpDate(
  value: Date | string | null | undefined,
): string {
  const date = asDate(value);
  if (!date) return "אין";
  return date.toLocaleDateString("he-IL");
}
